import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import SidebarProvider from "@/v2-backoffice-client/components/sidebar/SidebarProvider"

export type PageProps = ComponentProps<"main">

function Page(props: PageProps) {
  const { className, ...mainProps } = props
  return (
    <SidebarProvider>
      <main className={cn("page", className)} {...mainProps} />
    </SidebarProvider>
  )
}

export default Page
